class CeHeaderPromoSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-ce-promo-slide]'));
    this.prevButton = this.querySelector('[data-ce-promo-prev]');
    this.nextButton = this.querySelector('[data-ce-promo-next]');
    this.index = 0;

    if (this.slides.length < 2) {
      this.prevButton?.setAttribute('disabled', 'disabled');
      this.nextButton?.setAttribute('disabled', 'disabled');
      return;
    }

    this.prevButton?.addEventListener('click', () => this.go(-1));
    this.nextButton?.addEventListener('click', () => this.go(1));
    this.updateButtons();
  }

  go(delta) {
    this.index = (this.index + delta + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === this.index);
    });
    this.updateButtons();
  }

  updateButtons() {
    if (this.slides.length < 2) return;
    this.prevButton?.removeAttribute('disabled');
    this.nextButton?.removeAttribute('disabled');
  }
}

customElements.define('ce-header-promo-slider', CeHeaderPromoSlider);
